import { render, staticRenderFns } from "./document-account-details.vue?vue&type=template&id=530d9426&scoped=true&"
import script from "./js/document-account-details.js?vue&type=script&lang=js&"
export * from "./js/document-account-details.js?vue&type=script&lang=js&"
import style0 from "./document-account-details.vue?vue&type=style&index=0&id=530d9426&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d9426",
  null
  
)

export default component.exports